import { createRouter, createWebHashHistory  } from 'vue-router'

// 導入多字命名元件
import HomePage from './views/HomePage.vue'
import AboutPage from './views/AboutPage.vue'
import FoodMachine from './views/FoodMachine.vue'
import ProductListPage from './views/ProductListPage.vue'
import ContactPage from './views/ContactPage.vue'
import NotFoundPage from './views/NotFoundPage.vue'
import ProductPage from './views/ProductPage.vue'
import IntroducePage from './views/IntroducePage.vue'
import BrandPage from './views/BrandPage.vue'
import WebDesignPage from './views/WebDesignPage.vue'
import GoddesPage from './views/GoddesPage.vue'

const routes = [
  { path: '/', component: HomePage },
  { path: '/about', component: AboutPage },
  { path: '/food-machine', name: 'FoodMachine', component: FoodMachine },
  { path: '/products/:id', name:'ProductListPage', component: ProductListPage },
  { path: '/contact', component: ContactPage },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundPage },
  { path: '/product/:id',  name: 'ProductPage',  component: ProductPage},
  { path: '/introduce', component: IntroducePage},
  { path: '/brand', component: BrandPage},
  { path: '/web-design', name: 'WebDesign', component: WebDesignPage},
  { path: '/goddes', name: 'Goddes', component: GoddesPage}
]

const router = createRouter({
  history: createWebHashHistory (),
  routes
})

export default router